import { useEffect, useRef } from 'react';
import { css } from '@emotion/core';
import { decodeBlurHash } from 'fast-blurhash';
export const ThumbnailBlurhash = ({ blurhash, }) => {
    const blurhashRef = useRef(null);
    useEffect(() => {
        if (blurhash && (blurhashRef === null || blurhashRef === void 0 ? void 0 : blurhashRef.current)) {
            const blurhashCanvas = blurhashRef.current;
            blurhashCanvas.width = 90;
            blurhashCanvas.height = 160;
            const context = blurhashCanvas.getContext('2d');
            const pixels = decodeBlurHash(blurhash, 90, 160);
            const outputImageData = new ImageData(pixels, 90, 160);
            context === null || context === void 0 ? void 0 : context.putImageData(outputImageData, 0, 0);
        }
    }, [blurhash]);
    return (<canvas role="presentation" ref={blurhashRef} css={css `
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
      `}></canvas>);
};
